<div class="wrap">
  <div class="validation">
    <div class="validation_mail">
      <div class="check">
        <span class="icon-line line-tip"></span>
        <span class="icon-line line-long"></span>
        <div class="icon-circle"></div>
        <div class="icon-fix"></div>
      </div>
    </div>
    <p>Votre désinscription a bien été prise en compte</p>
    <p class="redirection">Redirection en cours <span>.</span><span>.</span><span>.</span> </p>
  </div>
</div>